/**
 * /tenants/$slug/authentication/sign-in/passkeys — what a passkey needs.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { queryKeys } from "@/lib/query-keys";
import { fetchAllowlist } from "@/features/authenticator-allowlist/queries";
import { microcopyQueryOptions } from "@/features/microcopy/queries";
import { tenantCapabilities } from "@/features/tenants/capabilities";
import { signInAvailability, signInSectionPresent } from "@/features/signin-settings/sections";
import { PasskeysSection } from "@/features/signin-settings/pages/passkeys-section";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/sign-in/passkeys")({
  beforeLoad: ({ context, params }) => {
    const tenant = context.settingsTenant;
    if (!signInSectionPresent("passkeys", tenant, tenantCapabilities(tenant))) {
      throw redirect({ to: "/tenants/$slug/authentication/sign-in", params: { slug: params.slug } });
    }
  },
  // The approved-models status reads the list's size. Prefetch, not ensure:
  // without permission to read the list the status still renders. The phone
  // option title reads the tenant's wording.
  loader: ({ context }) => {
    const tenant = context.settingsTenant;
    const av = signInAvailability(tenant, tenantCapabilities(tenant), () => true);
    return Promise.all([
      context.queryClient.prefetchQuery({
        queryKey: queryKeys.authenticatorAllowlist.list(context.tenant.id),
        queryFn: () => fetchAllowlist(context.tenant.id),
      }),
      av.passkeys?.phoneOptionTitle ? context.queryClient.prefetchQuery(microcopyQueryOptions(tenant.id)) : undefined,
    ]);
  },
  component: PasskeysSection,
});
